import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectMfaLoading = (store: StoreSchema) => store.loginState.mfaLoading